var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4165 7.4227C7.1415 5.6922 8.8275 4.0037 10.4745 2.3572C10.5607 2.26658 10.6088 2.14628 10.6088 2.0212C10.6088 1.89612 10.5607 1.77583 10.4745 1.6852C10.2413 1.4257 9.87225 1.4482 9.70425 1.6252C7.99725 3.3367 6.2115 5.12545 4.347 6.99145C4.199 7.11295 4.125 7.25645 4.125 7.42195C4.125 7.58745 4.199 7.73545 4.347 7.86595L9.95925 13.3455C10.067 13.4443 10.209 13.4973 10.3552 13.4933C10.5013 13.4892 10.6402 13.4284 10.7423 13.3237C11.0108 13.0545 10.9073 12.789 10.7858 12.663C8.99319 10.9186 7.20319 9.17158 5.41575 7.42195",
    fill: "#366EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/Prev.557ef471a17134aef323915dcec9f99e.svg";
export { ForwardRef as ReactComponent };